/* eslint-disable no-console */
import axios from 'axios'
import { camelCase } from 'change-case'

const isObject = (target) => Object.prototype.toString.call(target).slice(8, -1)
    .toLowerCase() === 'object'
const convertSnakeToCamel = (target) => {
    if (Array.isArray(target)) {
        target.forEach((t) => convertSnakeToCamel(t))
    }
    if (isObject(target)) {
        Object.keys(target).forEach((key) => {
            if (isObject(target[key]) || Array.isArray(target[key])) {
                convertSnakeToCamel(target[key])
            }
            // スネークケースをキャメルケースに変換する
            if (key.includes('_')) {
                target[camelCase(key)] = target[key]
                delete target[key]
            }
        })
    }
}

const repository = axios.create({
    baseURL: 'http://localhost:8080/api/',
    headers: { "X-Requested-With": "XMLHttpRequest" },
})

repository.interceptors.response.use(
    // 2XX範囲内のステータスコード
    (response) => {
        if (response.data) {
            convertSnakeToCamel(response.data)
        }
        return response
    },
    // 2XX範囲外のステータスコード
    (error) => {
        let customError = {}

        if (error.response) {
            customError = {
                id : error.response.data.id,
                code : error.response.data.code,
                message:  error.response.data.message,
            }
        } else if (error.request) {
            // レスポンスが返ってこないときのエラーハンドリング
            customError = {
                message:  '通信に失敗しました。',
            }
            console.log(error.request)
        } else {
            customError = {
                message:  error.message,
            }
        }
        error.customError = customError
        return Promise.reject(error)
    }
)
export default repository
